import React from 'react';
import { TFunction } from 'react-i18next';
import { Nullable } from '@dxb-web-ui-framework/common/types';
import { Box } from '@dxb-web-ui-framework/design-system';
import { GetApp as DownloadTransactionDetailsIcon } from '@material-ui/icons';
import { DrawerAction } from '../../../../../content-composer/src/components/Generic/GenericDrawer/GenericDrawer';
import { ECOMMBXLoader } from '../../../../../content-composer/src/components/Generic/ECOMMBXLoader/ECOMMBXLoader';
import { ConsolidatedTransactionDetails } from '../../../domain/Transaction/entities/ConsolidatedTransaction';

const TransactionDrawerDownloadAction: ({
  isLoadingPrint,
  onPrintTransactionDetails,
  transactionDetails,
  isAuthorization,
  t,
}: {
  isLoadingPrint: boolean;
  onPrintTransactionDetails: (orderId: number) => void;
  transactionDetails: Nullable<ConsolidatedTransactionDetails>;
  isAuthorization?: boolean;
  downloadComponent?: React.FC;
  t: TFunction;
}) => DrawerAction[] = ({
  isLoadingPrint,
  onPrintTransactionDetails,
  transactionDetails,
  isAuthorization,
  t,
}): DrawerAction[] => [
  {
    dataTestId: `download-transaction-details`,
    icon: (
      <>
        {isLoadingPrint && (
          <Box display={'flex'} alignItems={'center'}>
            <ECOMMBXLoader size='small' />
          </Box>
        )}
        {!isLoadingPrint && <DownloadTransactionDetailsIcon color='secondary' />}
      </>
    ),
    variant: 'text',
    color: 'secondary',
    size: 'small',
    disabled: false,
    onClick: () => (transactionDetails ? onPrintTransactionDetails(transactionDetails?.orderId) : {}),
    isIconButton: true,
    title: isAuthorization
      ? t('transactionDetailsDrawer.actions.isAuthorizedBtn.Title')
      : t('transactionDetailsDrawer.actions.isNotAuthorizedBtn.Title'),
  },
];
export { TransactionDrawerDownloadAction };
